<rask-header [uppercase]="true">
    {{ 'ADMINISTRATION_LAGERSALDO_PROLOG_HEADER' | translate}}
</rask-header>
<rask-container-block>
    <ng-container header>{{ 'ADMINISTRATION_LAGERSALDO_PROLOG_CARD_LABEL' | translate}}</ng-container>
    <rask-response-panel
        [show]="!!result"
        label="Resultat ({{result}})"
        message="{{result}}">
    </rask-response-panel>
    <rask-input [label]="'ADMINISTRATION_LAGERSALDO_PROLOG_LABEL' | translate" [(ngModel)]="lagerplatsId"></rask-input>
    <ng-container footer>
        <rask-button color="secondary" (click)="updateLagersaldo()">
            {{ 'DEFAULT_LABEL_HAMTA' | translate}}</rask-button>
    </ng-container>
</rask-container-block>
